const SCHEMA_VERSION = 3;
const Allowed = {
  "page:viewed": ["url_path", "referrer_host", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "event_schema_version"],
  "user:signup": ["auth_provider", "referrer_host", "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "event_schema_version"],
  "plot:attempted": ["dataset_id_hash", "prompt_len", "transforms_hint", "columns_selected", "credits_before", "event_schema_version"],
  "run:started": ["run_id", "dataset_id_hash", "model_name", "queue_latency_ms", "credits_spent_estimate", "event_schema_version"],
  "run:succeeded": ["run_id", "dataset_id_hash", "duration_ms", "rows_plotted", "transforms_applied", "points_plotted", "model_name", "credits_spent", "event_schema_version"],
  "run:failed": ["run_id", "dataset_id_hash", "duration_ms", "error_stage", "error_class", "error_hash", "credits_charged", "event_schema_version"],
  "chart:saved": ["run_id", "dataset_id_hash", "fig_type", "format", "name_customized", "event_schema_version"],
  "chart:downloaded": ["run_id", "format", "fig_type", "event_schema_version"],
  "credit:granted": ["amount", "grant_reason", "balance_after", "event_schema_version"],
  "credit:spent": ["amount", "reason", "balance_after", "run_id", "event_schema_version"],
  "dataset:uploaded": ["dataset_id_hash", "rows", "cols", "source", "storage_provider", "bytes", "mime", "file_ext", "ingest_method", "event_schema_version"],
  "dataset:ready": ["draft_id", "dataset_id_hash", "rows", "cols", "bind_method", "event_schema_version"],
  "plan:card_shown": ["plan_id", "draft_id", "dataset_id_hash", "chart_type", "rank", "recommended", "event_schema_version"],
  "run:confirmed": ["run_id", "draft_id", "dataset_id_hash", "model_name", "columns_selected", "transforms_hint", "credits_spent_estimate", "event_schema_version"]
};
function allowedProps(event) {
  return new Set(Allowed[event]);
}
function validateAndFilter(event, props) {
  const allow = allowedProps(event);
  const out = {};
  out.event_schema_version = SCHEMA_VERSION;
  for (const k of Object.keys(props || {})) {
    if (!allow.has(k)) continue;
    out[k] = props[k];
  }
  out.event_schema_version = SCHEMA_VERSION;
  return out;
}
function jsonSchema(event) {
  const props = Array.from(allowedProps(event));
  const properties = {};
  for (const k of props) properties[k] = { type: ["string", "number", "boolean"] };
  return {
    $schema: "http://json-schema.org/draft-07/schema#",
    title: `Event ${event}`,
    type: "object",
    additionalProperties: false,
    properties,
    required: props
  };
}
export {
  SCHEMA_VERSION,
  allowedProps,
  jsonSchema,
  validateAndFilter
};
